import { apiBaseURL } from '@/api/API';

export const MemberNotificationTypeOptions = [
    { value: '', text: '全部類型' },
    { value: 'general', text: '一般通知' },
    { value: 'pre-departure', text: '行前須知' },
    { value: 'emergency', text: '緊急公告' },
    { value: 'payment', text: '付款通知' },
    { value: 'refund', text: '退費通知' },
];

export const memberNotificationTypeText = (type) => {
    const option = MemberNotificationTypeOptions.find((item) => item.value === type);
    return option ? option.text : type;
};

const notificationImagePathPattern = /\/files\/_description\/camp-notification\/[A-Za-z0-9_-]{1,128}\/[a-f0-9]{32}\.(?:jpe?g|png|webp)$/i;

const allowedNotificationImageOrigins = () => {
    const origins = new Set([window.location.origin]);

    try {
        origins.add(new URL(apiBaseURL, window.location.origin).origin);
    } catch (_) {
        // Invalid environment URLs are ignored; same-origin images remain allowed.
    }

    return origins;
};

const sanitizeNotificationImage = (element) => {
    const source = element.getAttribute('src');
    if (!source) return false;

    try {
        const imageUrl = new URL(source, window.location.origin);
        if (!['http:', 'https:'].includes(imageUrl.protocol)) return false;
        if (!allowedNotificationImageOrigins().has(imageUrl.origin)) return false;
        if (!notificationImagePathPattern.test(imageUrl.pathname)) return false;

        const allowedAttributes = new Set(['src', 'alt', 'title', 'width', 'height']);
        Array.from(element.attributes).forEach((attribute) => {
            if (!allowedAttributes.has(attribute.name.toLowerCase())) {
                element.removeAttribute(attribute.name);
            }
        });

        ['width', 'height'].forEach((name) => {
            const value = element.getAttribute(name);
            if (value && !/^\d{1,4}$/.test(value)) element.removeAttribute(name);
        });

        return true;
    } catch (_) {
        return false;
    }
};

export const sanitizeNotificationHtml = (html) => {
    if (!html || typeof DOMParser === 'undefined') return '';

    const documentNode = new DOMParser().parseFromString(html, 'text/html');
    const allowedTags = new Set([
        'A', 'B', 'BLOCKQUOTE', 'BR', 'DIV', 'EM', 'H1', 'H2', 'H3', 'H4',
        'H5', 'H6', 'HR', 'I', 'IMG', 'LI', 'OL', 'P', 'PRE', 'S', 'SPAN', 'STRONG',
        'TABLE', 'TBODY', 'TD', 'TFOOT', 'TH', 'THEAD', 'TR', 'U', 'UL',
    ]);
    const allowedAttributes = new Set(['colspan', 'rowspan', 'title']);

    Array.from(documentNode.body.querySelectorAll('*')).forEach((element) => {
        if (!allowedTags.has(element.tagName)) {
            element.replaceWith(...Array.from(element.childNodes));
            return;
        }

        if (element.tagName === 'IMG') {
            if (!sanitizeNotificationImage(element)) element.remove();
            return;
        }

        Array.from(element.attributes).forEach((attribute) => {
            const name = attribute.name.toLowerCase();
            if (element.tagName === 'A' && name === 'href') {
                const href = attribute.value.trim();
                if (!/^(https?:|mailto:|tel:)/i.test(href)) element.removeAttribute(attribute.name);
                return;
            }
            if (!allowedAttributes.has(name)) element.removeAttribute(attribute.name);
        });

        if (element.tagName === 'A' && element.hasAttribute('href')) {
            element.setAttribute('target', '_blank');
            element.setAttribute('rel', 'noopener noreferrer');
        }
    });

    return documentNode.body.innerHTML;
};
